import type { SVGAttributes } from 'react';

export function CampaignsIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				opacity="0.4"
				d="M26.4801 10.7868C26.4801 11.3468 26.4401 11.8934 26.3734 12.4134C25.7601 12.1468 25.0934 12.0001 24.3868 12.0001C22.7601 12.0001 21.3201 12.7868 20.4268 13.9868C19.5201 12.7868 18.0801 12.0001 16.4534 12.0001C13.7201 12.0001 11.5068 14.2268 11.5068 16.9868C11.5068 20.5601 13.4001 23.2934 15.5068 25.1468C15.4401 25.1868 15.3734 25.2001 15.3068 25.2268C14.9068 25.3735 14.2401 25.3735 13.8401 25.2268C10.3868 24.0401 2.66675 19.1334 2.66675 10.7868C2.66675 7.10677 5.62674 4.13345 9.28007 4.13345C11.4534 4.13345 13.3734 5.17344 14.5734 6.78677C15.7867 5.17344 17.7067 4.13345 19.8667 4.13345C23.5201 4.13345 26.4801 7.10677 26.4801 10.7868Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M29.3333 16.9867C29.3333 23.2267 23.5599 26.9067 20.9733 27.7867C20.6666 27.8933 20.1732 27.8933 19.8666 27.7867C18.7599 27.4133 17.0666 26.52 15.5066 25.1466C13.3999 23.2933 11.5066 20.56 11.5066 16.9867C11.5066 14.2267 13.7199 12 16.4532 12C18.0799 12 19.5199 12.7867 20.4266 13.9867C21.3199 12.7867 22.7599 12 24.3866 12C25.0933 12 25.7599 12.1467 26.3733 12.4133C28.1199 13.1867 29.3333 14.9333 29.3333 16.9867Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
